import { t } from "i18next";
import React, { useState } from "react";
import styled from "styled-components";
import { ChannelContext } from "../../../context/channel";
import { ENV, WL_URL } from "../../../settings";
import BackIcon from "../../shared/Icons/BackIcon";
import DesktopIcon from "../../shared/Icons/DesktopIcon";
import MobileIcon from "../../shared/Icons/MobileIcon";
import IPhoneFrame from "../iPhoneFrame/IPhoneFrame";
import { PREVIEW_FOR } from "./enums";

interface IPreviewModal {
  setShowPreviewModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedSettingsPage: string;
}

const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(8, 8, 17, 0.8);
  cursor: pointer;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const ExitModalContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 82px;
  background-color: ${(props) => props.theme.colors.secondary};
`;

const ExitModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 20%;
  margin-left: 60px;
  cursor: pointer;
`;

const ExitModalTitle = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  width: 100%;
  margin-left: 15px;
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 6%;
  height: 100%;
  min-width: 100px;
  margin-left: 25%;
`;

const Icon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const DotSelectContainer = styled.div`
  height: 5px;
  width: 2px;
  align-self: center;
`;

const DotSelect = styled.div`
  align-self: center;
  height: 4px;
  width: 4px;
  background-color: white;
  border-radius: 50%;
`;

const IFrame = styled.iframe`
  width: 100%;
  height: 90%;
`;

const PreviewModal: React.FC<IPreviewModal> = ({
  setShowPreviewModal,
  selectedSettingsPage,
}) => {
  const { channel } = React.useContext(ChannelContext);

  let hostName = WL_URL;
  if (ENV === "staging") {
    hostName = "https://stg-whitelabel.eventials.com";
  }

  const [previewFor, setPreviewFor] = useState(PREVIEW_FOR.DESKTOP);
  return (
    <ModalWrapper>
      <ModalContainer>
        <ExitModalContainer>
          <ExitModal onClick={() => setShowPreviewModal(false)}>
            <BackIcon />
            <ExitModalTitle>{t('dashboard.preview.back')}</ExitModalTitle>
          </ExitModal>
          <IconsContainer>
            <Icon>
              <DesktopIcon
                onClick={() => setPreviewFor(PREVIEW_FOR.DESKTOP)}
                previewFor={previewFor}
                previewSelected={PREVIEW_FOR.DESKTOP}
              />
              <DotSelectContainer>
                {previewFor === PREVIEW_FOR.DESKTOP && <DotSelect></DotSelect>}
              </DotSelectContainer>
            </Icon>
            <Icon>
              <MobileIcon
                onClick={() => setPreviewFor(PREVIEW_FOR.MOBILE)}
                previewFor={previewFor}
                previewSelected={PREVIEW_FOR.MOBILE}
              />
              <DotSelectContainer>
                {previewFor === PREVIEW_FOR.MOBILE && <DotSelect></DotSelect>}
              </DotSelectContainer>
            </Icon>
          </IconsContainer>
        </ExitModalContainer>
        {previewFor === PREVIEW_FOR.DESKTOP && (
          <IFrame
            src={`${hostName}/${channel}?preview=true#${selectedSettingsPage}`}
            title="White Label Preview"
          />
        )}
        {previewFor === PREVIEW_FOR.MOBILE && (
          <IPhoneFrame style={{ alignSelf: "center", marginTop: "40px" }}>
            <IFrame
              src={`${hostName}/${channel}?preview=true#${selectedSettingsPage}`}
              title="White Label Mobile Preview"
              style={{
                border: "none",
                borderRadius: "30px",
                height: "96%",
                width: "100%",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            />
          </IPhoneFrame>
        )}
      </ModalContainer>
    </ModalWrapper>
  );
};

export default PreviewModal;
